import React, { useState } from 'react';
import Icon from 'components/AppIcon';

import StatusBadge from './StatusBadge';
import RoleBadge from './RoleBadge';

const UserTableRow = ({ user, currentUserRole, onAction, isSelected, onSelect }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const canModify = currentUserRole === 'SUPER_ADMIN' || (currentUserRole === 'ADMIN' && user?.role !== 'SUPER_ADMIN');

  const actions = [];
  if (user?.status === 'ACTIVE') actions?.push({ key: 'suspend', label: 'Suspender', icon: 'UserX', danger: true });
  if (user?.status === 'SUSPENDED') actions?.push({ key: 'reactivate', label: 'Reactivar', icon: 'UserCheck', danger: false });
  if (user?.status === 'PENDING') {
    actions?.push({ key: 'activate', label: 'Activar', icon: 'CheckCircle', danger: false });
    actions?.push({ key: 'reject', label: 'Rechazar', icon: 'XCircle', danger: true });
  }
  actions?.push({ key: 'reset_password', label: 'Restablecer contraseña', icon: 'Key', danger: false });
  actions?.push({ key: 'view', label: 'Ver perfil', icon: 'Eye', danger: false });

  return (
    <tr className="border-b border-gray-100 hover:bg-gray-50 transition-colors">
      <td className="px-4 py-3">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={(e) => onSelect(user?.id, e?.target?.checked)}
          className="w-4 h-4 rounded border-gray-300 text-teal-600 focus:ring-teal-500"
        />
      </td>
      <td className="px-4 py-3">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-8 h-8 rounded-full bg-teal-100 flex items-center justify-center flex-shrink-0">
            <span className="text-xs font-bold text-teal-700 font-heading">
              {user?.name?.split(' ')?.map(n => n?.[0])?.slice(0, 2)?.join('')?.toUpperCase()}
            </span>
          </div>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-gray-800 font-heading truncate">{user?.name}</p>
            <p className="text-xs text-gray-500 font-caption truncate">{user?.email}</p>
          </div>
        </div>
      </td>
      <td className="px-4 py-3 hidden md:table-cell">
        <div>
          <p className="text-sm text-gray-700 font-body truncate max-w-[160px]">{user?.organization}</p>
          <p className="text-xs text-gray-400 font-caption">NIT: {user?.nit}</p>
        </div>
      </td>
      <td className="px-4 py-3">
        <RoleBadge role={user?.role} />
      </td>
      <td className="px-4 py-3">
        <StatusBadge status={user?.status} />
      </td>
      <td className="px-4 py-3 hidden lg:table-cell">
        <p className="text-xs text-gray-500 font-caption whitespace-nowrap">{user?.lastLogin}</p>
      </td>
      <td className="px-4 py-3">
        {canModify ? (
          <div className="relative">
            <button
              onClick={() => setMenuOpen(v => !v)}
              className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 text-gray-500 transition-colors"
              aria-label="Acciones"
            >
              <Icon name="MoreVertical" size={16} />
            </button>
            {menuOpen && (
              <>
                <div className="fixed inset-0 z-40" onClick={() => setMenuOpen(false)} />
                <div className="absolute right-0 top-9 z-50 bg-white border border-gray-200 rounded-xl shadow-lg py-1 min-w-[200px]">
                  {actions?.map(action => (
                    <button
                      key={action?.key}
                      onClick={() => { onAction(user, action?.key); setMenuOpen(false); }}
                      className={`w-full flex items-center gap-2.5 px-4 py-2.5 text-sm font-caption hover:bg-gray-50 transition-colors text-left ${action?.danger ? 'text-red-600' : 'text-gray-700'}`}
                    >
                      <Icon name={action?.icon} size={14} color={action?.danger ? '#DC2626' : 'currentColor'} />
                      {action?.label}
                    </button>
                  ))}
                </div>
              </>
            )}
          </div>
        ) : (
          <span className="text-xs text-gray-400 font-caption">—</span>
        )}
      </td>
    </tr>
  );
};

export default UserTableRow;